import admin from './admin'
import tracking from './tracking'
import misc from './misc'
import demo from './demo'

export default {admin, tracking, misc, demo}